'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$31() {
  this.bh2 = null;
  this.bh0 = null;
  this.bh1 = false;
  this.bgY = null;
  this.bgZ = false;
  this.bh3 = false;
  this.bh4 = false;
  this.bh2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$31 as $c_Lpresto_PrestoRouter$$anon$31 };
$p = $c_Lpresto_PrestoRouter$$anon$31.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$31;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$31() {
}
export { $h_Lpresto_PrestoRouter$$anon$31 as $h_Lpresto_PrestoRouter$$anon$31 };
$h_Lpresto_PrestoRouter$$anon$31.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bh2;
});
$p.t = (function() {
  if ((!this.bh1)) {
    this.bh0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh1 = true;
  }
  return this.bh0;
});
$p.ae = (function() {
  if ((!this.bgZ)) {
    this.bgY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgZ = true;
  }
  return this.bgY;
});
$p.w = (function() {
  if ((!this.bh4)) {
    this.bh3 = false;
    this.bh4 = true;
  }
  return this.bh3;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$31 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$31, "presto.PrestoRouter$$anon$31", ({
  NX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$31 as $d_Lpresto_PrestoRouter$$anon$31 };
//# sourceMappingURL=presto.-Presto-Router$$anon$31.js.map
